import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';

import { TOption } from '@treezor/design-system';

import { ICardTransactionFilterFormFields } from '@/store/types/card-transactions.type';
import { ISearch } from '@/ui-kit/table-filters/filters.type';

export function mapCardTransactionSearch(value) {
  return { [value.key]: value.value };
}

export function useCardTransactionSearchField(methods: UseFormReturn<ICardTransactionFilterFormFields>, onChange) {
  const { t } = useTranslation();

  const handleSearchChange = useCallback(
    (value: ISearch) => {
      const currentValue = methods.getValues('search');
      const newValue = Object.keys(value).reduce<ISearch>((prev, current) => {
        return { ...prev, [current]: value[current] === null ? currentValue[current] : value[current] };
      }, {} as ISearch);
      methods.setValue('search', newValue);
      if (value.key !== null && value.value !== null) {
        onChange();
      }
    },
    [onChange, methods],
  );

  const setSearchValue = useCallback(
    (key: string, value: string) => {
      methods.setValue('search', { key, value });
      onChange();
    },
    [methods, onChange],
  );

  const searchOptions: TOption[] = [
    { label: t('pages.currentProfiles.cards.filters.payment.paymentId'), value: 'paymentId' },
    { label: t('pages.currentProfiles.cards.card.walletId'), value: 'walletId' },
  ];
  const searchValue = methods.watch('search');

  return { value: searchValue, handleChange: handleSearchChange, setSearchValue, options: searchOptions };
}
